function stringToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function StringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      height: "32px",
      width: "32px",
      fontSize: "0.9rem",
      fontWeight: 700
    },
    children: `${name.toUpperCase().split(" ")[0][0]}${name.toUpperCase().split(" ")[1][0]}`,
  };
}

export default StringAvatar;
